import { useEffect, useState } from "react"

import { Modal, Spin, Typography } from "antd"
import { useDispatch, useSelector } from "react-redux"

import ButtonComponent from "../../../../Components/Button"
import GenerateLinkForm from "../../../../Components/Forms/GenerateLinkForm"
import { generateLink } from "../../redux/marketing.thunks"

const { Text } = Typography

const GenerateLink = () => {
  const [openModal, setOpenModal] = useState(false)
  const dispatch = useDispatch()

  const { options, saveFetching, saveResult } = useSelector((state) => state.marketing)
  const isMobile = useSelector((state) => state.nav.isMobile)

  const handleCloseModal = () => {
    setOpenModal(false)
  }

  useEffect(() => {
    if (saveResult?.type === "generate_link" && openModal) handleCloseModal()
  }, [saveResult])

  const handleSubmitForm = (data) => {
    dispatch(generateLink(data))
  }

  return (
    <>
      <ButtonComponent onClick={() => setOpenModal(true)}>Generate link</ButtonComponent>

      <Modal
        open={openModal}
        centered={!isMobile}
        width={442}
        title="Generate link"
        footer={null}
        closable="true"
        onCancel={handleCloseModal}
        destroyOnClose
        classNames={{ content: "clear-bg" }}
      >
        <Spin size="large" spinning={saveFetching}>
          <GenerateLinkForm
            options={options}
            onSubmit={handleSubmitForm}
            onClose={handleCloseModal}
          />
        </Spin>
      </Modal>
    </>
  )
}

export default GenerateLink
